import Cart from '@/models/Cart';

export const state = () => {
  return {
    cart: new Cart(),
    activeSlide: 0,
  };
};

export const actions = {
  addPacket({ commit }, packet) {
    commit('addPacket', packet);
  },
  addSaldo({ commit }, saldo) {
    commit('addSaldo', saldo);
  },
  clear({ commit }) {
    commit('clear');
  },
  setSlide({ commit }, slide) {
    commit('setActiveSlide', slide);
  },
  clearSaldo({ commit }) {
    commit('clearSaldo');
  },
  clearPacket({ commit }) {
    commit('clearPacket');
  },
  setServiceClass({ commit }, serviceClass) {
    commit('setServiceClass', serviceClass);
  },
  setSaldoMultiplier({ commit }, mul) {
    commit('setSaldoMultiplier', mul);
  },
  setSaldoDiscount({ commit }, discount) {
    commit('setSaldoDiscount', discount);
  },
  setTopupMin({ commit }, topupMin) {
    commit('setTopupMin', topupMin);
  },
  clearSaldoDiscount({ commit }) {
    commit('clearSaldoDiscount');
  },
};

export const mutations = {
  setSaldoDiscount(state, discount) {
    state.cart.saldoDiscount = discount;
  },
  setTopupMin(state, topupMin) {
    state.cart.topupMin = topupMin;
  },
  addPacket(state, packet) {
    state.cart.packet = packet;
  },
  addSaldo(state, saldo) {
    state.cart.saldo = saldo;
  },
  clear(state) {
    state.cart = new Cart();
  },
  clearSaldo(state) {
    state.cart.saldo = 0;
  },
  clearPacket(state) {
    state.cart.packet = null;
  },
  setActiveSlide(state, slide) {
    state.activeSlide = slide;
  },
  setSaldoMultiplier(state, mul) {
    state.cart.saldoMultiplier = mul;
  },
  setServiceClass(state, serviceClass) {
    state.cart.serviceClass = serviceClass;
  },
  clearSaldoDiscount: state => {
    state.cart.saldoDiscount = null;
    state.cart.topupMin = null;
  },
};

export const getters = {
  cart: state => state.cart,
  slide: state => state.activeSlide,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
